export default "__VITE_ASSET__CNj7xmPE__"